"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var $ = require("jquery");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var SubscribeButtonComponent = (function (_super) {
    __extends(SubscribeButtonComponent, _super);
    function SubscribeButtonComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.currentUserSubscription = ko.observable();
        this.btnCss = ko.pureComputed(function () {
            if (_this.params.mode === "small")
                return "btn-sm";
            var css = "";
            var isActive = _this.currentUserSubscription();
            if (!isActive) {
                css = "btn-success-brd";
            }
            return css;
        });
        this.processing = ko.observable(false);
        this.mainContentMarkup = ko.pureComputed(function () {
            var currentUserSubscription = _this.currentUserSubscription(), targetUserSubscription = _this.targetUserSubscription;
            if (!currentUserSubscription) {
                if (targetUserSubscription) {
                    return "<i class=\"icon-user-plus\"></i> Добавить в друзья";
                }
                return "<i class=\"icon-plus\"></i> Подписаться";
            }
            if (currentUserSubscription.isMutual) {
                return "<i class=\"icon-users\"></i> Вы друзья <span class=\"caret\"></span>";
            }
            if (currentUserSubscription.dontShowUpdates) {
                return "<i class=\"icon-check text-bold\"></i> Вы подписаны <span class=\"caret\"></span>";
            }
            return "<i class=\"icon-check text-bold\"></i> Вы подписаны";
        });
        this.toggleDontShowUpdatesMarkup = ko.pureComputed(function () {
            var currentUserSubscription = _this.currentUserSubscription();
            if (currentUserSubscription && currentUserSubscription.dontShowUpdates) {
                return "<span style=\"margin-right: 25px\"></span>Показывать новости";
            }
            return "<i class=\"icon-check mr-sm text-bold\"></i> Показывать новости";
        });
        this.unsubscribeMarkup = ko.pureComputed(function () {
            var currentUserSubscription = _this.currentUserSubscription();
            if (currentUserSubscription && currentUserSubscription.isMutual) {
                return "<i class=\"icon-user-minus mr-sm\"></i> Удалить из друзей";
            }
            return "<span style=\"margin-right: 22.5px\"></span>Отписаться";
        });
        this.openPopover = function () {
            if (!_this.$popover) {
                _this.$popover = $(_this.element).siblings(".popover");
                _this.$popover.appendTo(document.body);
            }
            app.f7.popover(_this.$popover[0], $(_this.element).siblings(".btn-subscribe")[0]);
        };
        this.toggle = function (toggleOnlyShowingUpdates) {
            if (!app.ensureAuth("Только зарегистрированные пользователи могут осуществлять подписки.")) {
                return;
            }
            if (_this.processing())
                return;
            _this.processing(true);
            ajaxUtils_1.AjaxUtils.post("subscription/updateSubscription", {
                userId: _this.userId,
                toggleOnlyShowingUpdates: toggleOnlyShowingUpdates,
                subscribe: !_this.currentUserSubscription()
            }).done(function (result) {
                if (result.isSuccessful) {
                    _this.currentUserSubscription(result.data);
                    if (!result.data) {
                        if (_this.$popover) {
                            var modal = _this.$popover[0];
                            if (modal) {
                                app.f7.closeModal(modal);
                            }
                        }
                    }
                    else {
                        if (toggleOnlyShowingUpdates) {
                            if (result.data.dontShowUpdates) {
                                alert("Вы больше не будете получать уведомлений о действиях пользователя.");
                            }
                            else {
                                alert("Вы снова будете получать уведомления о действиях пользователя.");
                            }
                        }
                    }
                }
                else {
                    alert(result.messages[0]);
                }
            }).always(function () {
                _this.processing(false);
            });
        };
        if (params.subscriptionInfo) {
            this.currentUserSubscription(params.subscriptionInfo.currentUserSubscription);
            this.targetUserSubscription = params.subscriptionInfo.targetUserSubscription;
        }
        this.userId = params.userId;
    }
    return SubscribeButtonComponent;
}(baseComponent_1.default));
ko.components.register("mobile-subscribe-button", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SubscribeButtonComponent;
//# sourceMappingURL=mobileSubscribeButton.js.map